import { createSlice } from '@reduxjs/toolkit';
import {
  fetchGoogleImagePull,
  updateGoogleImagePull
} from './settings.actions';

const initialState = {
  isGoogleImagePull: null,
  isLoading: false
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setGoogleImagePull(state, action) {
      state.isGoogleImagePull = action.payload;
    },
    resetSettings(state) {
      state.isGoogleImagePull = initialState.isGoogleImagePull;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGoogleImagePull.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGoogleImagePull.fulfilled, (state, action) => {
      state.isLoading = false;
      if (!action.payload) return;
      state.isGoogleImagePull = action.payload.isGoogleImagePull;
    });
    builder.addCase(fetchGoogleImagePull.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateGoogleImagePull.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateGoogleImagePull.fulfilled, (state, action) => {
      state.isLoading = false;
      if (!action.payload) return;
      state.isGoogleImagePull = action.payload.isGoogleImagePull;
    });
    builder.addCase(updateGoogleImagePull.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const { setGoogleImagePull, resetSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
